import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useDropzone } from 'react-dropzone';

import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  dropFieldSx?: SxProps;
  isUploading: boolean;
  onUploadData: (file: File) => Promise<void>;
}

export const FileUpload: React.FC<Props> = props => {
  const { dropFieldSx, isUploading, onUploadData } = props;
  const { t } = useTranslationWithPrefix('components.fileUpload');

  const handleDrop = (acceptedFiles: File[]) => {
    void (async () => {
      await onUploadData(acceptedFiles[0]);
    })();
  };

  const { getInputProps, getRootProps } = useDropzone({
    multiple: false,
    onDrop: handleDrop,
  });

  return (
    <Box
      {...getRootProps({ className: 'dropzone' })}
      sx={{
        justifyContent: 'center',
        minHeight: '150px',
        ...dropFieldSx,
        cursor: isUploading ? 'wait' : 'default',
      }}
    >
      <input {...getInputProps()} />
      <Typography sx={{ color: themeColors.greyDark, textAlign: 'center' }}>
        {isUploading ? (
          <Stack direction="row" spacing={3} sx={{ alignItems: 'center' }}>
            {t('isUploading')}
            <CircularProgress size={24} sx={{ color: themeColors.accentColor }} />
          </Stack>
        ) : (
          t('title')
        )}
      </Typography>
    </Box>
  );
};
